import 'regenerator-runtime/runtime.js';
import '@joinbox/ui-components/YouTubePlayer/YouTubePlayerElement.js';
import '@joinbox/ui-components/Media/AudioComponentElement.js';
import '@joinbox/ui-components/Media/MediaPlayPauseComponentElement.js';
import '@joinbox/ui-components/Media/MediaTimeComponentElement.js';
import '@joinbox/ui-components/Media/MediaTimelineComponentElement.js';
import '@joinbox/ui-components/Media/MediaVolumeComponentElement.js';
import '@joinbox/ui-components/Overlay/OverlayButtonElement.js';
import '@joinbox/ui-components/Overlay/OverlayElement.js';
import '../../template-library/components/cookie-banner/CookieBanner.js';
import '../../template-library/components/cookie-banner/CookieCheck.js';
import '../../template-library/components/navigation/NavigationItem.js';

import initMobileNavigationScrollLock from '../../template-library/components/navigation/initMobileNavigationScrollLock.js';
import initCookieBannerTriggerButton from '../../template-library/components/cookie-banner/initCookieBannerTriggerButton.js';
import initFormElementFocusedState from '../../template-library/components/form/initFormElementFocusedState.js';
import initValidationForSubmittedForms from '../../template-library/components/form/initValidationForSubmittedForms.js';

initMobileNavigationScrollLock();
initCookieBannerTriggerButton();
initFormElementFocusedState();
initValidationForSubmittedForms();
